import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../contexts/authContext";
import { AxiosRequestConfig } from "axios";
import Style from "./CategoryDetailsStyle";
import Spinner from "../../shared/Spinner/Spinner";
import api from "../../services/api";
import InfoModal from "../../shared/Bootstrap/InfoModal";
import PageTitle from "../../components/PageTitle";
import { InputImage } from "../../components/InputImage/InputImage";
import { GetFileFromURL } from "../../utils";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";


const ownerCompanyId = 1;

export default function CategoryDetails(props) {
  const { userData } = useContext(AuthContext);
  const [categoryName, setCategoryName] = useState("");
  const [categoryImage, setCategoryImage] = useState("");
  const [deleteImage, setDeleteImage] = useState(false);
  const [selectedFile, setSelectedFile] = useState({} as File);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const categoryId = parseInt(props.match?.params?.categoryId) || 0;
  const creatingNew = categoryId <= 0;

  useEffect(() => {
    if (!creatingNew)
      LoadCategory();

  }, []);

  function goBack() {
    props.history.goBack();
  }

  async function LoadCategory() {
    try {
      setLoading(true);
      const result = await api.get(`/productsCategories/${categoryId}`);
      if (result.data.success) {
        const category = result.data.category;
        setCategoryName(category.category);
        setCategoryImage(category.iconUrl);
      }
    }
    catch (error: any) {
      setErrorMessage(error.response?.data?.message || "Não foi possível carregar categoria");
    }
    finally {
      setLoading(false);
    }
  }

  async function OnSubmit() {
    setLoading(true);
    try {
      onClosePopup()
      const options: AxiosRequestConfig = {};
      const formData = new FormData();
      if (selectedFile.name && !deleteImage) {
        formData.append("image", selectedFile, selectedFile.name);
      }
      formData.append("category", categoryName);
      if (!creatingNew) {
        formData.append("deleteImage", deleteImage.toString());
      }
      await (creatingNew ? api.post("/productsCategories", formData, options) : api.put(`/productsCategories/${categoryId}`, formData, options));
      LoadCategory();
      setErrorMessage("");
      if (creatingNew) {
        goBack();
      }
      else {
        setCategoryImage("")
        setShowSuccessPopup(true);
        LoadCategory();
      }
    }
    catch (error: any) {
      setErrorMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
      setShowSuccessPopup(true);
    }
  }

  function ChangeFileSelected(event) {
    setSelectedFile(event.target.files[0]);
    setDeleteImage(false);
  };

  function ShowSuccessPopup() {
    return (
      <InfoModal
        show={showSuccessPopup}
        onHide={() => setShowSuccessPopup(false)}
        loading={false}
        title="Categoria editada com sucesso!"
        body="Suas edições da categoria foram salvas com sucesso" 
        primaryText="OK"
        primaryOnClick={() => setShowSuccessPopup(false)}
        primaryDisabled={false}
      />
    )
  }
  function onOpenPopUp() {
    setShowPopup(true);
  }

  function onClosePopup() {
    setShowPopup(false);
  }

  function GetImageUrl(): string {
    return categoryImage ? GetFileFromURL(categoryImage, `${process.env.REACT_APP_BASE_URL}/productsCategories/${categoryId}/image`) : categoryImage;
  }

  const disabled = loading || (userData.companyId !== ownerCompanyId && !creatingNew);

  return (
    <Style>
      {ShowSuccessPopup()}
      <PageTitle title="Detalhes da Categoria" />
      <div className="category">
        <TwoButtonsModal
          show={showPopup}
          onHide={onClosePopup}
          loading={false}
          title={creatingNew ? "Cadastrar categoria" : "Editar categoria"}
          body={"Você tem certeza que deseja " + (creatingNew ? "cadastrar esta categoria?" : "editar esta categoria?")}
          secondaryText="Fechar"
          secondaryOnClick={onClosePopup}
          secondaryDisabled={loading}
          primaryText="Confirmar"
          primaryOnClick={OnSubmit}
          primaryDisabled={loading}
        />
        <div>
          <button onClick={() => goBack()} className="btn-secondary backButton" >Voltar</button>
        </div>
        <Spinner spinning={loading} />
        {errorMessage && <p className="alert alert-error">Erro: {errorMessage}</p>}
        <main>
          <div className="panel">
            <form className="main-form" onSubmit={(e) => { e.preventDefault() }}>

              <h2>Edição de Categoria</h2>
              <div>
                <label>Categoria: </label>
                <input
                  autoComplete="product-name"
                  disabled={!creatingNew}
                  value={categoryName}
                  onChange={e => setCategoryName(e.target.value)}
                />
              </div>
              <div>
                <label>Imagem:</label>
                <InputImage
                  id="file"
                  label=""
                  name="file"
                  alt="Imagem do produto"
                  acceptedMimeTypes="image/png, image/jpeg"
                  imageUrl={GetImageUrl()}
                  OnChange={ChangeFileSelected}
                  OnRemove={() => setDeleteImage(true)}
                  image={selectedFile}
                />
              </div>
              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                disabled={disabled}
                onClick={e => {
                  e.preventDefault();
                  onOpenPopUp();
                }}>{creatingNew ?
                  "Adicionar" :
                  "Editar"}
              </button>
            </form>
          </div>
        </main>
      </div>
    </Style >
  );
}
